import React from 'react';
import { Flex } from '@qga/roo-ui/components';

import { PackageOption } from '@shared/v2/utils/getPackageOptions/getPackageOptions';

import { PackageOptionProps } from '@/v2/components/ui/AllPackageOptionsModal/components/PackageOption/PackageOption';
import packageTranslations from '@/v2/locales/en/package.json';
import Modal from '../../layout/Modal';
import PropertyTitle from '../PropertyTitle';
import PackageOptionCard from './components/PackageOption';

interface AllPackageOptionsModal {
  onClose: Function;
  tile: any;
  property: any;
  packageOptions: PackageOption[];
  onClickViewPackageDetailsAndTerms?: Function;
  viewPackageDetailsAndTermsContent?: (
    overrideProps: object,
  ) => React.FC<Function>;
}

const mapPackageOptionToComponent =
  ({
    property,
    propertyId,
    ...props
  }: Pick<
    PackageOptionProps,
    'onClickViewPackageDetailsAndTerms' | 'viewPackageDetailsAndTermsContent'
  > & {
    property: any;
    propertyId: string;
  }) =>
  (option: PackageOption) => {
    const bestOffer = option.cheapestOffer;

    return (
      <PackageOptionCard
        id={option.id}
        optionNumber={option.optionNumber}
        key={option.id}
        propertyId={propertyId}
        title={option.title}
        offer={bestOffer}
        inclusions={option.inclusions}
        isPresearch={true}
        property={property}
        {...props}
      />
    );
  };

const AllPackageOptionsModal = ({
  onClose,
  property,
  packageOptions,
  onClickViewPackageDetailsAndTerms,
  viewPackageDetailsAndTermsContent,
}: AllPackageOptionsModal) => (
  <Modal size="lg" bg="background.page" onClose={onClose}>
    <Modal.Header>
      {packageTranslations.packageOptions.modal.title}
    </Modal.Header>
    <Modal.Body>
      <Flex
        bg="background.card"
        pb={['16px', null, 6]}
        pt={['16px', null, 4]}
        px={['16px', null, 5]}
      >
        <PropertyTitle
          propertyName={property.name}
          rating={property.rating}
          ratingType={property.ratingType}
          type={'HOLIDAY_PACKAGE'}
          tags={property.tags || []}
        />
      </Flex>
      <Flex
        flexDirection="column"
        bg={'background.page'}
        pb={['16px', null, 6]}
        pt={['16px', null, 4]}
        px={['16px', null, 5]}
        gap={'16px'}
      >
        {packageOptions.map(
          mapPackageOptionToComponent({
            propertyId: property.id,
            onClickViewPackageDetailsAndTerms,
            viewPackageDetailsAndTermsContent,
            property,
          }),
        )}
      </Flex>
    </Modal.Body>
  </Modal>
);

export default AllPackageOptionsModal;
